import { mixins, styled } from '@bob/library'
import { Link } from 'gatsby'

interface ThumbnailWrapperProps {
  borderColor?: string
}

// To prevent this warning: "<a> cannot appear as a descendant of <a>"
export const ProductLink = styled(Link)`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
`

export const Item = styled(Link)`
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;
  position: relative;
  z-index: 0;
`

export const ThumbnailWrapper = styled.div<ThumbnailWrapperProps>`
  display: flex;
  align-items: center;
  position: relative;
  ${mixins.padding(20, 20)};
  ${mixins.margin.bottom(10)};
  border: ${({ borderColor }) =>
    borderColor ? `2px solid ${borderColor}` : `1px solid ${mixins.colors.grayLowlight}`};
  width: 100%;
  height: 200px;
  ${mixins.media.min.tablet} {
    height: 300px;
  }
  border-radius: 16px;
  .productBandImage {
    display: flex;
    ${mixins.padding.top(10)};
    ${mixins.padding.bottom(0)};
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    & img {
      display: block;
      width: auto;
      max-height: 100%;
      max-width: 100%;
      position: relative;
    }
  }
`

export const TopWrapper = styled.div`
  ${mixins.padding(0, 10)};
  position: absolute;
  top: 10px;
  right: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const LabelWrapper = styled.div`
  ${mixins.margin.left(10)};
  text-align: right;
`

export const GradesWrapper = styled.div`
  display: flex;
  align-items: center;
  ${mixins.typography.paragraphSmall};
  & > svg {
    fill: ${({ theme }) => theme.colors.grayDark};
    ${mixins.margin.right(10)}
  }
`

export const PriceWrapper = styled.div`
  display: flex;
`

export type OriginalPriceProps = {
  isDiscounted: boolean
}

export const OriginalPrice = styled.div<OriginalPriceProps>`
  ${mixins.typography.paragraphMedium};
  color: ${mixins.colors.grayBlack};
  text-decoration: ${({ isDiscounted }) => (isDiscounted ? 'line-through' : 'none')};
`

export const DiscountPrice = styled.div`
  ${mixins.typography.noColor.paragraphMedium};
  ${mixins.margin.left(10)};
  color: ${mixins.colors.corporateRed};
`

export const Title = styled.h3`
  ${mixins.margin.top(5)};
  ${mixins.margin.bottom(5)};
  ${mixins.typography.headlineSmall};
  ${mixins.media.min.desktop} {
    width: 100%;
  }
`

export const AddToCartButton = styled.button`
  ${mixins.cta.tertiary('blue')}
  ${mixins.padding.left(0)}
  z-index: 1;
`

export const Retired = styled(Link)`
  ${mixins.cta.tertiary('blue')}
  ${mixins.padding.left(0)}
  z-index: 1;
`

export const ErrorMessage = styled.div`
  ${mixins.margin.top(10)}
  ${mixins.typography.noColor.paragraphSmall}
  color: ${mixins.colors.corporateRed};
  font-style: italic;
`
